import { render, staticRenderFns } from "./ImoFalFormsGeneralForm.vue?vue&type=template&id=1de6ff4f"
import script from "./ImoFalFormsGeneralForm.vue?vue&type=script&lang=js"
export * from "./ImoFalFormsGeneralForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports